export const supportedLanguages: LanguageSpec[] = [
  {
    code: 'en',
    name: 'English',
    short: 'EN',
    englishName: 'English',
    direction: 'ltr',
    isVisible: true,
  },
  {
    code: 'cimode',
    name: 'CI Mode',
    short: 'TEST',
    englishName: 'CI Mode',
    direction: 'ltr',
    isVisible: false,
  },
];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export const NS_BASE = 'base';

export const NS_BASE_GENERATED = 'base.generated';

export const NS_COMMONWEALTH = 'commonwealth';

export const NAMESPACES = [NS_COMMONWEALTH, NS_BASE, NS_BASE_GENERATED];

export type SupportedLocale = 'en' | 'cimode';

export type Translation = Record<string, unknown>;

interface LanguageSpec {
  code: SupportedLocale;
  name: string;
  short: string;
  englishName: string;
  direction: 'ltr' | 'rtl';
  isVisible: boolean;
}
